/**
 * @react-settings-pane
 *
 * @copyright Dennis Stücken
 * @licence MIT
 */
import React, { Component } from "react";
import MenuItem from "./MenuItem";

export class SettingsMenu extends Component {
  /**
   * PropTypes
   *
   * @type {{items: *, headline: *, currentPage: *, switchcontent: *, onMenuItemClick: *}}
   */
  // static propTypes = {
  //   headline: PropTypes.string.isRequired,
  //   items: PropTypes.array,
  //   currentPage: PropTypes.string,
  //   switchcontent: PropTypes.func,
  //   onMenuItemClick: PropTypes.func
  // };

  /**
   * Itearate through all items and return an array of MenuItems
   *
   * @returns array
   */
  menuItems() {
    let props;

    return this.props.items.map((item) => {
      // Define all props for this MenuItem
      props = {
        item,
        active: this.props.currentPage === item.url,
        onMenuItemClick: this.props.onMenuItemClick,
        switchcontent: this.props.switchcontent,
      };

      return <MenuItem key={item.url} {...props} />;
    });
  }

  /**
   * Render this component
   *
   * @returns {XML}
   */
  render() {
    return (
      <div className="settings-left">
        <ul className="settings-menu">
          {this.props.headline ? <li className="headline">{this.props.headline}</li> : ""}
          {this.menuItems()}
        </ul>
      </div>
    );
  }
}

export default SettingsMenu;
